<template>
    <div v-wechat-title="title" class="padding10">
        <el-row>
            <el-col :span="24">
                <el-scrollbar :style="{ height: this.screenHeight - 30 + 'px' }">
                    <div v-if="recoveryBeds.length > 0" class="recoveryBeds" :style="{ height: screenHeight - 60 + 'px' }">
                        <el-card v-for="p in recoveryBeds" :key="p.location_id" class="recoveryBedCard" :body-style="{ padding: '5px' }">
                            <div class="card-header">
                                <el-row class="height30 padding5 padding-none-v" type="flex" align="middle">
                                    <el-col :span="22" style="line-height: 30px">
                                        <b>{{ p.location }}</b>
                                        <span v-if="p.visit" style="float: right" :title="p.visit.patient_name">
                                            <b class="fg-primary">{{ splitName(p.visit.patient_name) }}</b>
                                            {{ p.visit && `${p.visit.sex || '--'}/${p.visit.age || '--岁'}` }}
                                            <span class="circle fg-red borderd" v-if="p.visit.is_reoperation">再</span>&nbsp;&nbsp;
                                        </span>
                                        <template v-else>(空)</template>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="card-content">
                                <!-- <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%" v-if="p && p.visit"> -->
                                <el-row v-if="p && p.visit">
                                    <el-col :span="24" class="padding5">
                                        <div style="min-height: 30px; border-bottom: dashed 0.5px lightgrey" v-show="showInfo(1) || showInfo(2) || showInfo(3)">
                                            <el-row style="max-height: 30px" v-show="showInfo(1)">
                                                <el-col :span="24"><span class="fg-info">手术：</span>{{ (p.visit.surgeries && p.visit.surgeries) || '--' }}</el-col>
                                            </el-row>
                                            <el-row style="max-height: 30px" v-show="showInfo(2)">
                                                <el-col :span="24"><span class="fg-info">诊断：</span>{{ (p.visit && p.visit.diseases) || '--' }}</el-col>
                                            </el-row>
                                            <el-row style="max-height: 30px" v-show="showInfo(3) || showInfo(4)">
                                                <el-col :span="10" v-show="showInfo(3)"><span class="fg-info">床号：</span>{{ (p.visit && p.visit.bed_no) || '--' }} </el-col>
                                                <el-col :span="14" v-show="showInfo(4)"
                                                    ><span class="fg-info">房间：</span>{{ (p.visit && p.visit.dic_operating_room) || '--' }}</el-col
                                                >
                                            </el-row>
                                            <el-row style="max-height: 30px" v-show="showInfo(11) || showInfo(12)">
                                                <el-col :span="12" v-show="showInfo(11)"><span class="fg-info">住院号：</span>{{ (p.visit && p.visit.visit_no) || '--' }}</el-col>
                                                <el-col :span="12" v-show="showInfo(12)"><span class="fg-info">科室：</span>{{ (p.visit && p.visit.dic_section) || '--' }}</el-col>
                                            </el-row>
                                        </div>
                                        <div class="hand padding5 padding-none-h" style="border-bottom: dashed 0.5px lightgrey">
                                            <div class="padding5 padding-none-h" style="display: inline-block; width:45%;" v-show="showInfo(5)">麻醉医师：{{ p.visit.anes_doctor }}</div>
                                            <div class="padding5 padding-none-h" style="display: inline-block;width:45%;" v-show="showInfo(6)">手术医师：{{ p.visit.surgeon }}</div>
                                            <div class="padding5 padding-none-h" v-show="showInfo(7)">
                                                出手术间时间：<span>{{ $moment(p.visit.out_room_time).format('MM/DD HH:mm') }}</span>
                                            </div>
                                            <div class="padding5 padding-none-h" v-show="showInfo(8)">
                                                入室体温：<span :class="{ 'fg-danger': p.visit && p.visit.temperature && p.visit.temperature < 35.5 }">{{
                                                    (p.visit.temperature && `${p.visit.temperature} ℃`) || '--'
                                                }}</span>
                                            </div>
                                            <div class="padding5 padding-none-h" v-show="showInfo(9)">
                                                入复苏室时间：
                                                <span class="fg-danger" v-if="checkDatetime(p.visit.in_recovery_room)" title="复苏超过3小时">{{
                                                    $moment(p.visit.in_recovery_room).format('MM/DD HH:mm')
                                                }}</span>
                                                <span v-else>{{ $moment(p.visit.in_recovery_room).format('MM/DD HH:mm') }}</span>
                                            </div>
                                            <div class="dt padding5 padding-none-h" v-show="showInfo(10)">
                                                麻醉开始时间：
                                                <span v-if="p.visit">{{ p.visit.anesthesia_begin && $moment(p.visit.anesthesia_begin).format('MM/DD HH:mm') }}</span>
                                                <!-- <text-formatter type="datetime" v-model="p.visit.anesthesia_begin" v-if="p.visit"></text-formatter> -->
                                            </div>
                                        </div>
                                        <div class="line-height24 align-left margin-none-h">
                                            <el-row>
                                                <el-col :span="11" class="margin5" style="font-weight: bold;" v-for="item in p.monitor_datas" :key="item.physio_param.id">
                                                    {{ item.physio_param.alias || item.physio_param.name }}：<b :class="{ 'fg-danger': item.is_warning }">{{ item.value }}</b>
                                                {{ item.physio_param.unit }}
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-col>
                                </el-row>
                                <!-- </el-scrollbar> -->

                                <div v-else>
                                    <div class="no-patient">
                                        <div class="icon"><font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon></div>
                                        <!-- <div v-for="l in list" :key="l.id">{{l.patient_name}}</div> -->
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <div v-else>
                        <div class="icon" style="line-heigth: 500px; font-size: 300px; opacity: 0.2">
                            <font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon>
                        </div>
                        <p class="no-surgery">暂无苏醒床位</p>
                    </div>
                </el-scrollbar>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import Json5 from 'json5'
import { mapGetters } from 'vuex'
export default {
    name: `RecoveryScreenQuery`,
    props: {},
    data() {
        // 监听页面回传消息
        window.addEventListener(`message`, (event) => {
            let d = _.startsWith(event.data, `{`) && Json5.parse(event.data) || {}
            if (d.order == `refreshRevList`) {
                this.c = 1
                this.loadRecoveryBeds()
            }
        }, false)
        return {
            title: `复苏记录大屏`,
            defaultRecordBedCount: 6,
            recoveryBeds: [],
            token: sessionStorage.getItem(`token`),
            user: this.$route.query.user,
            pwd: this.$route.query.pwd,
            list: [],
            c: 1,
            recoveryBedsInfoConfigs: this.$root.RecoveryBoardConfig && this.$root.RecoveryBoardConfig.split(`|`).map(d => parseInt(d)) || [],
            // bedIds: this.$root.RecoverybedScreenConfig && this.$root.RecoverybedScreenConfig.split(`,`).map(d => parseInt(d)) || [],
            beds: []

        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    created() {
        let that = this
        this.loadToken().then(() => {
            this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
            clearInterval(this.interval)
            this.interval = setInterval(() => {
                this.loadMonitorData()
            }, 10000)
            that.loadRecoverybedScreenConfig()
            this.loadRecoveryBeds()
        })
    },
    mounted() {
        this.c = 1
    },
    computed: {
        ...mapGetters([`recovery_ward_auth`, `recovery_ward_auth_disabled`, `recovery_bed_auth`, `screenHeight`])
    },
    methods: {
        loadToken() {
            return new Promise(resolve => {
                this.username = this.user
                let password = decodeURIComponent(this.pwd)
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: this.username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    resolve(data)
                })
            })
        },
        loadRecoverybedScreenConfig() {
            // TODO:获取参数配置中默认手术间数量
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=RecoverybedScreenConfig`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var array = data.value.split(`,`).map(d => parseInt(d))
                    that.bedIds = array
                }
            }).catch(e => {})
        },
        showInfo(num) {
            let that = this
            return (that.recoveryBedsInfoConfigs && _.includes(that.recoveryBedsInfoConfigs, num)) || that.recoveryBedsInfoConfigs.length == 0
        },
        splitName(name) {
            if (this.defaultRecordBedCount == 6 || this.defaultRecordBedCount == 8) {
                // 名字超长处理
                if (name.length > 4) {
                    name = name.substring(0, 4) + `...`
                }
            }
            return name
        },
        loadRecoveryBeds() {
            let that = this
            let req1 = this.myaxios.get(`/api/Postoperative/Recovery/Recoverings`)
            req1.then(recoverings => {
                if (this.bedIds.length > 0) {
                    let beds = _.map(_.filter(this.recovery_bed_auth, function(i) {
                        return _.includes(that.bedIds, i.value)
                    }), d => {
                        return {
                            location_id: d.value,
                            location: d.label,
                            visit: _.find(recoverings, { dic_recovery_bed_id: d.value }),
                            monitor_datas: []
                        }
                    })
                    this.recoveryBeds = beds
                }
                that.loadMonitorData()
            })
        },
        loadMonitorData() {
            let req2 = this.myaxios.post(`/api/Operation/Monitor/MonitorDataV2?recordType=2`, _.filter(this.recoveryBeds, d => d.visit).length > 0 ? _.map(_.filter(this.recoveryBeds, d => d.visit), d => d.location_id) : this.bedIds)
            req2.then(datas => {
                _.forEach(datas, dts => {
                    let index = _.findIndex(this.recoveryBeds, m => m.location_id == dts.location_id)
                    let r = { ...this.recoveryBeds[index] }
                    r.check_result = dts.check_result
                    r.defaulPhysioparmas = dts.defaulPhysioparmas
                    if (dts.defaulPhysioparmas) {
                        let monitordatas = []
                        _.forEach(dts.defaulPhysioparmas, b => {
                            var physioparma = _.find(dts.monitor_datas, c => b.id == c.id || b.id == c.dic_physio_param_id)
                            if (physioparma) {
                                monitordatas.push(physioparma)
                            } else {
                                monitordatas.push({
                                    physio_param: {
                                        id: b.id,
                                        alias: b.alias,
                                        name: b.name,
                                        unit: b.unit
                                    },
                                    is_warning: false,
                                    value: `--`
                                })
                            }
                        })
                        dts.monitor_datas = monitordatas
                        r.monitor_datas = dts.monitor_datas
                        this.$set(this.recoveryBeds, index, r)
                    }
                })
                if (this.c < 6) {
                    ++this.c
                } else {
                    this.c = 1
                }
            })
        },
        checkDatetime(dat) {
            if (dat) {
                return this.$moment(dat).add(3, `hours`).isBefore(this.$moment())
            }
            return false
        }
    }
}
</script>
<style  lang="less" scoped>
.recoveryBeds {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    .recoveryBedCard {
        flex-grow: 1;
        height: auto;
        // min-height: 380px;
        width: 23%;
        margin:10px;
        /deep/ .el-card__body {
            display: flex;
            align-items: stretch;
            flex-direction: column;
            height: 100%;
            .card-header {
                text-align: left;
                font-size: 18px;
                font-family: Arial;
                /*background: darkkhaki;*/
            }
            .card-content {
                flex-grow: 1;
                // padding: 14px;
                // min-height: 360px;
                text-align: left;
                background: #f5f6f7;
                font-size: 20px;
                .dt {
                    color: darkgoldenrod;
                }
                .el-row {
                    padding: 2px !important;
                }
                //  .el-col {
                //   padding: 0 !important;
                //   font-size:12px;
                // }
                .no-patient {
                    text-align: center;
                    color: grey;
                    opacity: 0.5;
                    height: 220px;
                    .icon {
                        font-size: 100px;
                        line-height: 240px;
                    }
                }
            }
        }
    }
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    border: solid 1px #dcdfe6;
    border-top: unset;
    li {
        border-top: solid 1px #dcdfe6;
        padding: 5px;
        font-size: 12px;
        cursor: move;
    }
}
.recovery-list-header {
    margin-top: 5px;
    background: var(--primary-color, #009688);
    color: white;
    line-height: 35px;
    text-align: center;
    border-bottom: solid 0.5px lightgray;
}
.chosenClass {
    background: lightgrey;
}
h1 {
    text-align: left;
    padding: 0;
    font-size: 30px;
    margin: 0;
}

//复苏床位
.tag {
    width: 100px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    float: left;
    margin-left: 20px;
    background: #cccccc;
    color: #000;
}
.used {
    background: var(--primary-color, #009688);
    color: #fff;
}
</style>
<style>
.theme-dark .el-dialog__body,
.theme-his-blue .el-dialog__body {
    padding: 0 20px 0 20px !important;
    overflow: auto;
    background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/Recovery/RecordScreen.vue